const DEFAULT_MAX_WIDTH = 1200;
const DEFAULT_MAX_HEIGHT = 520;
const DEFAULT_MAX_BYTES = 140 * 1024;
const DEFAULT_QUALITY = 0.82;

const getCanvasBlob = (canvas, type, quality) =>
  new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });

const loadImageFromBlob = (blob) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Unable to load image"));
    };
    image.src = url;
  });

export async function compressImageBlob(
  blob,
  {
    maxWidth = DEFAULT_MAX_WIDTH,
    maxHeight = DEFAULT_MAX_HEIGHT,
    maxBytes = DEFAULT_MAX_BYTES,
    mimeType = "image/jpeg",
    initialQuality = DEFAULT_QUALITY,
    minQuality = 0.52,
  } = {},
) {
  if (!blob?.type?.startsWith("image/")) return blob;

  const image = await loadImageFromBlob(blob);
  const ratio = Math.min(maxWidth / image.width, maxHeight / image.height, 1);
  const width = Math.max(1, Math.round(image.width * ratio));
  const height = Math.max(1, Math.round(image.height * ratio));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d", { alpha: false });
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);

  let quality = initialQuality;
  let output = await getCanvasBlob(canvas, mimeType, quality);

  while (output && output.size > maxBytes && quality > minQuality) {
    quality = Math.max(minQuality, quality - 0.1);
    output = await getCanvasBlob(canvas, mimeType, quality);
  }

  return output || blob;
}

export function createObjectUrlFromBlob(blob) {
  return URL.createObjectURL(blob);
}
